import { ApiError } from './api-error';

export class ForbiddenError extends ApiError {}
